import { c as _c } from "react/compiler-runtime";
import styles from "./CauseAreaIcon.module.scss";
const iconClassById: Record<number, string> = {
  1: styles.globalHealth,
  2: styles.animalWelfare,
  3: styles.futureGenerations,
  4: styles.operations,
  5: styles.other
};

/** The cause area's icon, or an empty icon-sized box for a cause area without one */
export const CauseAreaIcon: React.FC<{
  id: number;
}> = t0 => {
  const $ = _c(4);
  const {
    id
  } = t0;
  const t1 = iconClassById[id];
  let t2;
  if ($[0] !== t1) {
    t2 = [styles.icon, t1].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[2] !== t3) {
    t4 = <div className={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export const getCauseAreaIconById = (id: number) => <CauseAreaIcon id={id} />;
export const MultipleCauseAreaIcon: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={`${styles.icon} ${styles.multiple}`} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};